import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import CodebarIn from './CodebarIn'; // Verifique o caminho conforme necessário

const PackingBoxForm = ({ formData, handleChange, onBarcodesFinalized }) => {
  // Estados para o fluxo de códigos de barras
  const [barcodeInput, setBarcodeInput] = useState("");
  const [barcodes, setBarcodes] = useState([]);
  const [barcodeError, setBarcodeError] = useState("");
  const [localBarcodesFinalized, setLocalBarcodesFinalized] = useState(false);

  // Converte o número de paletes para número (ou 0, se inválido)
  const numPallets = parseInt(formData.number_of_pallets, 10) || 0;
  const remaining = numPallets - barcodes.length;

  // Exibe aviso se o número de paletes não estiver preenchido quando a opção "sim" estiver ativa
  const noPalletsWarning =
    formData.supplier_barcode === 'sim' && (!formData.number_of_pallets || numPallets === 0);

  // Renderiza o componente CodebarIn se a opção "Sim" estiver marcada e ainda houver paletes pendentes
  const showCodebarInput =
    formData.supplier_barcode === 'sim' && numPallets > 0 && barcodes.length < numPallets;

  // Função chamada ao pressionar Enter ou clicar no botão "Adicionar"
  const onBarcodeSubmit = () => {
    const code = barcodeInput.trim();
    if (!code) return;
    if (barcodes.includes(code)) {
      setBarcodeError("Código de barras já inserido.");
      return;
    }
    setBarcodes(prev => [...prev, code]);
    setBarcodeInput("");
    setBarcodeError("");
  };

  // Finaliza a inserção dos códigos quando o número inserido for igual ao número de paletes
  const finalizeBarcodes = () => {
    setLocalBarcodesFinalized(true);
    handleChange({ target: { name: 'supplier_barcodes', value: barcodes } });
    if (onBarcodesFinalized) onBarcodesFinalized(true);
  };

  useEffect(() => {
    // Se o usuário optou por utilizar os códigos do fornecedor ("sim")
    if (formData.supplier_barcode === 'sim' && numPallets > 0 && barcodes.length === numPallets && !localBarcodesFinalized) {
      finalizeBarcodes();
    }
    // Se o usuário optou por NÃO utilizar os códigos (valor "nao")
    if (formData.supplier_barcode === 'nao') {
      setBarcodes([]);
      setLocalBarcodesFinalized(true);
      handleChange({ target: { name: 'supplier_barcodes', value: [] } });
      if (onBarcodesFinalized) onBarcodesFinalized(true);
    }
  }, [formData.supplier_barcode, numPallets, barcodes, localBarcodesFinalized, handleChange, onBarcodesFinalized]);

  return (
    <div className="p-fluid">
      <div className="p-field">
        <label htmlFor="length">Comprimento</label>
        <InputText
          id="length"
          name="length"
          value={formData.length || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="width">Largura</label>
        <InputText
          id="width"
          name="width"
          value={formData.width || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="height">Altura</label>
        <InputText
          id="height"
          name="height"
          value={formData.height || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="material">Material</label>
        <InputText
          id="material"
          name="material"
          value={formData.material || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="description">Descrição</label>
        <InputText
          id="description"
          name="description"
          value={formData.description || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="quantity">Quantidade</label>
        <InputText
          id="quantity"
          name="quantity"
          value={formData.quantity || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="number_of_pallets">Número de Paletes</label>
        <InputText
          id="number_of_pallets"
          name="number_of_pallets"
          value={formData.number_of_pallets || ''}
          onChange={handleChange}
        />
      </div>
      <div className="p-field">
        <label htmlFor="last_pallet_quantity">Quantidade da Última Palete</label>
        <InputText
          id="last_pallet_quantity"
          name="last_pallet_quantity"
          value={formData.last_pallet_quantity || ''}
          onChange={handleChange}
        />
      </div>
      {/* Opção para utilizar os códigos de barras do fornecedor */}
      <div className="p-field-checkbox" style={{ display: 'flex', alignItems: 'center' }}>
        <label style={{ marginRight: '1rem' }}>Usar código de barras do fornecedor?</label>
        <Checkbox
          inputId="supplierBarcodeSim"
          name="supplier_barcode"
          checked={formData.supplier_barcode === 'sim'}
          onChange={() =>
            handleChange({ target: { name: 'supplier_barcode', value: 'sim' } })
          }
        />
        <label htmlFor="supplierBarcodeSim" style={{ marginRight: '1rem' }}>Sim</label>
        <Checkbox
          inputId="supplierBarcodeNao"
          name="supplier_barcode"
          checked={formData.supplier_barcode === 'nao'}
          onChange={() =>
            handleChange({ target: { name: 'supplier_barcode', value: 'nao' } })
          }
        />
        <label htmlFor="supplierBarcodeNao">Não</label>
      </div>

      {noPalletsWarning && (
        <div className="p-field">
          <p style={{ color: 'red' }}>
            Por favor, insira o número de paletes.
          </p>
        </div>
      )}

      {showCodebarInput && (
        <CodebarIn
          remaining={remaining}
          barcodeInput={barcodeInput}
          onBarcodeInputChange={(e) => setBarcodeInput(e.target.value)}
          onBarcodeSubmit={onBarcodeSubmit}
          barcodeError={barcodeError}
        />
      )}

      {localBarcodesFinalized && barcodes.length > 0 && (
        <div className="p-field">
          <h4>Códigos de Barras Finalizados:</h4>
          <table className="p-datatable p-component">
            <thead>
              <tr>
                <th>#</th>
                <th>Código de Barras</th>
              </tr>
            </thead>
            <tbody>
              {barcodes.map((code, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{code}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PackingBoxForm;
